import React from 'react';
import { STATUS_LABELS } from '../api/ticketsApi';

/** Every ticket status as its own tab (+ All). */
export const TICKET_STATUS_VALUES = [
  'open',
  'in_progress',
  'pending',
  'completed',
  'closed',
  'reopen',
  'cancelled',
];

export const TICKET_STATUS_TABS = [
  { id: 'all', label: 'All Tickets' },
  ...TICKET_STATUS_VALUES.map((id) => ({
    id,
    label: STATUS_LABELS[id] || id.replace(/_/g, ' '),
  })),
];

function TicketStatusTabs({ value, onChange }) {
  return (
    <div className="tk-segmented" role="tablist" aria-label="Ticket status filter">
      {TICKET_STATUS_TABS.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          aria-selected={value === tab.id}
          className={value === tab.id ? 'is-active' : ''}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}

/** Map tab id → API query params. Exact status filter for each status tab. */
export function statusTabToQuery(tab) {
  if (!tab || tab === 'all') return {};
  if (TICKET_STATUS_VALUES.includes(tab)) return { status: tab };
  return {};
}

export function queryToStatusTab(searchParams) {
  const status = searchParams.get('status');
  if (status && TICKET_STATUS_VALUES.includes(status)) return status;

  // Legacy overview links used status_group=open|closed
  const statusGroup = searchParams.get('status_group');
  if (statusGroup === 'closed') return 'closed';
  if (statusGroup === 'open') return 'open';

  return 'all';
}

export default TicketStatusTabs;
